/*
* External dependencies.
*/
import React from 'react';

/*
* Internal dependencies.
*/
import Header from 'blocks/header/header';
import ModalNewProject from 'components/modal-new-project/modal-new-project';

const LayoutBase = ({ children }) => (
	<div className="wrapper">
		<Header />

		<div className="content">
			{children}
		</div>

		<ModalNewProject />
	</div>
);

export default LayoutBase;
